import { API_ERROR_MESSAGES } from '@gestao/shared'

export const errors = {
  byCode: API_ERROR_MESSAGES,
  network: 'Sem resposta do servidor. Confira a conexão e tente de novo.',
  invalidResponse: 'O servidor respondeu num formato inesperado. Tente de novo em instantes.',
  rateLimited: (seconds: number) =>
    `Muitas tentativas seguidas. Aguarde ${seconds} ${seconds === 1 ? 'segundo' : 'segundos'} e tente de novo.`,
  routeTitle: 'Esta tela não abriu',
  routeDescription: 'Recarregue a página. Se continuar, avise o suporte com o horário do problema.',
  reload: 'Recarregar página',
} as const
